import React from 'react';

const AccountLocked = () => (
  <div id="main-wrapper">
    <div className="authincation section-padding">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-xl-4 col-md-5">
            <div className="mini-logo text-center my-3">
              <a href="./intro.html">
                <img src="./images/logo.png" alt="" />
              </a>
              <h4 className="card-title mt-3">Locked</h4>
            </div>
            <div className="auth-form card">
              <div className="card-body">
                <form action="index.html" className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Enter Password</label>
                    <input type="password" className="form-control" placeholder="***********" />
                  </div>
                  <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary btn-block">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default AccountLocked;
